import React from 'react';

import Button from 'components/Button';

const Control = ({ onClickAdd, onClickSplit, viewOnly }) => {
  return (
    <div className="bg-white shadow-soft-sm p-4 rounded">
      <Button
        onClick={() => {
          if (!viewOnly) {
            onClickAdd();
          }
        }}
        className="w-8 h-8 !rounded-full flex items-center !p-0"
        type="button"
        color="primary"
        icon={<img src={require('assets/resources/Plus.svg').default} alt="plus icon" width={18} height={18} />}
      />
      <Button
        onClick={() => {
          if (!viewOnly) {
            onClickSplit();
          }
        }}
        className="w-8 h-8 !rounded-full flex items-center !p-0 mt-4"
        type="button"
        color="outline"
        icon={<img src={require('assets/resources/SplitScreenAdd.svg').default} alt="plus icon" width={18} height={18} />}
      />
    </div>
  );
};

export default React.memo(Control);
